export const renderCategories = (value: string) => {
  switch (value) {
    case 'SOLE_TRADER':
      return 'A';
    case 'PARTNERS_NI':
      return 'B';
    case 'COMPANY':
      return 'D';
    default:
      return 'A';
  }
};

export const addTwoStringNumber = (gross: string, vat: string) => {
  return (
    parseFloat(Number(gross).toString()) + parseFloat(Number(vat).toString())
  );
};

